<template>
  <router-view></router-view>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>
  /* 路由切換收合導覽列選單時，停用動畫使其瞬間完成，避免收合過程的疊層殘留遮蔽中央內容 */
  .nav-collapse-instant .navbar-collapse,
  .nav-collapse-instant .navbar-collapse.collapsing {
    transition: none !important;
  }
</style>
